{
  "ChartstyleoptionsPie2d": "Tarte (2D)",
  "ChartstyleoptionsPie3d": "Tarte (3D)",
  "ChartstyleoptionsDoughnut2d": "Beignet (2D)",
  "ChartstyleoptionsDoughnut3d": "Beignet (3D)",
  "ChartstyleoptionsLine": "Ligne",
  "ChartstyleoptionsArea": "Zone",
  "ChartstyleoptionsAreastacked": "Surface (empilée)",
  "ChartstyleoptionsRadarpolararea": "Radar (zone polaire)",
  "ChartstyleoptionsColumn2d": "Colonne (2D)",
  "ChartstyleoptionsColumn2dstacked": "Colonnes (2D, empilées)",
  "ChartstyleoptionsColumn3d": "Colonne (3D)",
  "ChartstyleoptionsColumn3dstacked": "Colonne (3D, empilés)",
  "ChartstyleoptionsBar2d": "Bar (2D)",
  "ChartstyleoptionsBar2dstacked": "Barre (2D, empilées)",
  "ChartstyleoptionsBar3d": "Bar (3D)",
  "ChartstyleoptionsBar3dstacked": "Bar (3D, empilés)",
  "NAME": "ChartStyleOptions"
}